// extracted by mini-css-extract-plugin
module.exports = {"content":"fa627","wrapper":"_25f32","button":"_353f8"};